<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c2UvmZ/tc-custom/9781488035036.jpg?1703048324615" alt="This image is the cover for the book Missing Daughter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Missing Daughter
      </h1>
      <p class="bookDescription body article font2">
        <b>When a twelve-year-old girl goes missing, a suburban family’s perfect life reveals its dark secrets in this tense psychological thriller.</b><br/><br/>Life can change in an instant. For Ryan and Karen Lane, it happens on the morning they discover their twelve-year-old daughter’s window open, their beloved Maddie missing from her bed. Police investigate. Suspicions swirl. The Lane family is thrown into turmoil. Then detectives turn their sights on them.<br/><br/>No one is ruled out. Not Karen, with her tragic past, who argued with her daughter. Not Ryan, with his violent streak. Not Maddie’s thirteen-year-old brother, Tyler, who heard voices in her room the night she vanished.<br/><br/>As time goes by and no answers emerge, the Lanes fear that Maddie is gone forever. But when a stunning revelation shocks everyone, the family plunges deep into a world of buried secrets whose revelations threaten the very foundation of their lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Mofina
      </h2>
      
      <p class="authorDescription body article">Rick Mofina is a former crime reporter and the award-winning author of several acclaimed thrillers. He's interviewed murderers face-to-face on death row; patrolled with the LAPD and the RCMP. His true crime articles have appeared in The New York Times, Marie Claire, Reader&rsquo;s Digest and Penthouse. He's reported from the U.S., Canada, the Caribbean, Africa, Qatar and Kuwait's border with Iraq. For more information please&#160;visit www.rickmofina.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?464c00c8